import React, { useState } from "react";
import Drawer from "rsuite/Drawer";
import Highcharts from "highcharts";

const CustomerMapDrawer = ({ showCustomerMapFlag, showCustomerMapClose }) => {
  const [state, setState] = useState({ headerOpen: false });

  /* customer Map Start */
  const getCustomerMapData = async () => {
    try {
      const topology = await fetch(
        "https://code.highcharts.com/mapdata/custom/world.topo.json"
      ).then((res) => res.json());

      Highcharts.getJSON(
        `${process.env.REACT_APP_CRM}/crm/get-worlwide-customer-data`,
        ({ response }) => {
          Highcharts.mapChart("worldwide_customer_chart", {
            chart: {
              map: topology,
              height: 750,
              mapNavigation: { enabled: false },
            },
            exporting: { buttons: { contextButton: { enabled: false } } },
            title: {
              text: "",
              align: "center",
              verticalAlign: "bottom",
              y: 10,
              style: { fontSize: "12px", color: "rgb(102, 102, 102)" },
            },
            subtitle: { text: "" },
            credits: { enabled: false },
            mapNavigation: {
              enabled: true,
              buttonOptions: { verticalAlign: "bottom" },
            },
            colorAxis: {
              min: 1,
              type: "logarithmic",
              minColor: "#EEEEFF",
              maxColor: "rgb(25, 103, 210)",
              stops: [
                [0, "#EFEFFF"],
                [0.67, "#4444FF"],
                [1, "#000022"],
              ],
            },
            tooltip: {
              formatter() {
                return `${this.point.name}: ${this.point.value}`;
              },
            },
            series: [
              {
                data: response,
                states: { hover: { color: "#0063e1" } },
                dataLabels: { enabled: false, format: "{point.name}" },
                point: {
                  events: {
                    click({ point }) {
                      const clickedCountryCode = point.properties["hc-a2"];
                      const url = new URL(window.location.href);
                      url.searchParams.set("country", clickedCountryCode);
                      window.history.pushState({}, "", url.toString());

                      const updateState = (setter) =>
                        setter((prev) => ({
                          ...prev,
                          country_code: [clickedCountryCode],
                          customer_type: ["customer"],
                        }));

                      //   updateState(setInputTemp);
                      //   updateState(setInputValue);
                      setState((state) => {
                        return {
                          ...state,
                          headerOpen: true,
                        };
                      });
                    },
                  },
                },
              },
            ],
          });
        }
      );
    } catch (error) {
      console.error("Error fetching map data:", error);
    }
  };
  return (
    <Drawer
      open={showCustomerMapFlag}
      onClose={() => showCustomerMapClose()}
      onOpen={() => getCustomerMapData()}
      size="md"
    >
      <Drawer.Header>
        <Drawer.Title>Customer Map</Drawer.Title>
        <Drawer.Actions></Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <div id="worldwide_customer_chart" className="product-graph"></div>
      </Drawer.Body>
    </Drawer>
  );
};

export default CustomerMapDrawer;



// WEBPACK FOOTER //
// ./src/components/childcomponents/CustomerMapDrawer.js